var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.shipmentLabel.type
        ? _c("v-layout", { attrs: { wrap: "" } }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("type")) + ":  ")
            ]),
            _vm._v(_vm._s(_vm.shipmentLabel.type) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shipmentLabel.orderId
        ? _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c("v-flex", { staticClass: "text-xs-left" }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v("ID:  ")
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(" " + _vm._s(_vm.shipmentLabel._key))])
              ]),
              _vm._v(" "),
              _vm.isSingleFile || _vm.isFedexMWT
                ? _c("v-flex", [
                    _c(
                      "span",
                      {
                        staticClass: "more-info-text",
                        style: { cursor: "pointer", color: "#64B5F6" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showDetailTable.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.$t("moreInfo")) + "\n      "
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.user.isAdmin
                ? _c("v-flex", { staticClass: "text-xs-right" }, [
                    _vm._v("[" + _vm._s(_vm.index + 1) + "]")
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm.shipmentLabel.labelTaskKey
        ? _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c("v-flex", { staticClass: "text-xs-left" }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v("ID:  ")
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(" " + _vm._s(_vm.shipmentLabel.requestId))])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shipmentLabel.shipmentId
        ? _c("v-layout", { attrs: { wrap: "" } }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("shipmentID")) + ":  ")
            ]),
            _vm._v("\n    " + _vm._s(_vm.shipmentLabel.shipmentId) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shipmentLabel.itn
        ? _c("v-layout", { attrs: { wrap: "" } }, [
            _c("span", { staticClass: "font-weight-bold" }, [_vm._v("ITN:  ")]),
            _vm._v(" " + _vm._s(_vm.shipmentLabel.itn) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _vm.shipmentLabel.packages.length
            ? _c("v-flex", { attrs: { md5: "" } }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.$t("totalPkgQty")) + ": ")
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.isFedexMWT
                        ? _vm.shipmentLabel.packages.reduce(function(
                            sum,
                            label
                          ) {
                            return (sum += label.qty || 1)
                          },
                          0)
                        : _vm.shipmentLabel.packages.length
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-flex", { attrs: { md1: "" } }),
          _vm._v(" "),
          _vm.shipmentLabel.weight
            ? _c("v-flex", { attrs: { md6: "" } }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.$t("totalWeight")) + ": ")
                ]),
                _vm._v(" " + _vm._s(_vm.shipmentLabelWeight) + "\n    ")
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _vm.shipmentLabel.pricingOption === _vm.PRICING_OPTIONS.ONE_RATE
            ? _c("v-flex", { attrs: { md6: "" } }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.$t("packageType")) + ": ")
                ]),
                _vm._v(
                  "\n      " + _vm._s(_vm.shipmentLabel.packageType) + "\n    "
                )
              ])
            : _vm.shipmentLabel.packaging &&
              JSON.stringify(_vm.shipmentLabel.packaging) !== "{}"
            ? _c("v-flex", { attrs: { md6: "" } }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.$t("Size(L/W/H)")) + ": ")
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.displayPackaging(_vm.shipmentLabel.packages[0])
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-flex", { attrs: { md1: "" } })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-layout", [
        _c("span", { staticClass: "font-weight-bold text-capitalize" }, [
          _vm._v(_vm._s(_vm.$t("declaredValue")) + ": \n    ")
        ]),
        _vm._v("\n    " + _vm._s(_vm.shipmentLabel.insuredValue) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.shipmentLabel.signature
        ? _c("v-layout", [
            _c("span", { staticClass: "font-weight-bold text-capitalize" }, [
              _vm._v(_vm._s(_vm.$t("signature")) + ":  ")
            ]),
            _vm._v("\n    " + _vm._s(_vm.shipmentLabel.signature) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSupportSaturdayDelivery
        ? _c("v-layout", [
            _c("span", { staticClass: "font-weight-bold text-capitalize" }, [
              _vm._v(_vm._s(_vm.$t("supportSaturdayDelivery")))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shipmentLabel.memo || _vm.shipmentLabel.packages[0].memo
        ? _c("v-layout", { attrs: { wrap: "" } }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("memo")) + ":  ")
            ]),
            _vm._v(
              _vm._s(
                _vm.shipmentLabel.packages[0].memo || _vm.shipmentLabel.memo
              ) + "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shipmentLabel.isSupportHazmat || _vm.shipmentLabel.dangerousGoods
        ? _c(
            "v-layout",
            [
              _c("v-flex", { attrs: { md7: "" } }, [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.$t("dangerousGoods")) + ": ")
                ]),
                _vm._v("\n      " + _vm._s(_vm.dangerousGoodsLabel) + "\n    ")
              ]),
              _vm._v(" "),
              _vm.isBattery
                ? [
                    _c(
                      "span",
                      {
                        style: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showDangerousGoodsDetailTable.apply(
                              null,
                              arguments
                            )
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { small: "", color: "blue" } }, [
                          _vm._v("info")
                        ])
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shipmentLabel.note
        ? _c(
            "v-layout",
            {
              staticStyle: {
                "overflow-wrap": "break-word",
                "word-break": "break-all"
              },
              attrs: { wrap: "" }
            },
            [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("note")) + ":  ")
              ]),
              _vm._v(_vm._s(_vm.shipmentLabel.note) + "\n  ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shipmentLabel.reference
        ? _c(
            "v-layout",
            {
              staticStyle: {
                "overflow-wrap": "break-word",
                "word-break": "break-all"
              },
              attrs: { wrap: "" }
            },
            [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("reference")) + ":  ")
              ]),
              _vm._v(_vm._s(_vm.shipmentLabel.reference) + "\n  ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.user.isAdmin && _vm.shipmentLabel.clientName
        ? _c("v-layout", { attrs: { wrap: "" } }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("client")) + ":  ")
            ]),
            _vm._v(_vm._s(_vm.shipmentLabel.clientName) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shipmentLabel.orderKey
        ? _c("v-layout", { attrs: { wrap: "" } }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("orderKey")) + ":  ")
            ]),
            _vm._v(_vm._s(_vm.orderKey) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.detailToggle
        ? _c("LabelDetailPopup", {
            attrs: {
              shipmentLabel: _vm.shipmentLabel,
              isFedexMWT: _vm.isFedexMWT,
              isSingleFile: _vm.isSingleFile
            },
            model: {
              value: _vm.detailToggle,
              callback: function($$v) {
                _vm.detailToggle = $$v
              },
              expression: "detailToggle"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showBatteryDetailDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("hazMatsInfoDetail"),
              medium: "",
              hideRgtBtn: ""
            },
            on: {
              popupClose: function($event) {
                _vm.showBatteryDetailDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("HazardousCommodities", {
                        attrs: {
                          value: _vm.shipmentLabel.hazMatsInfo,
                          dangerousGoods: _vm.shipmentLabel.dangerousGoods,
                          offerorName: _vm.shipmentLabel.offerorName,
                          emergencyContactNumber:
                            _vm.shipmentLabel.emergencyContactNumber,
                          readonly: ""
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1508588737
            ),
            model: {
              value: _vm.showBatteryDetailDialog,
              callback: function($$v) {
                _vm.showBatteryDetailDialog = $$v
              },
              expression: "showBatteryDetailDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bec5f47c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bec5f47c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelDetailsWidget.vue
// module id = null
// module chunks = 